import { render, staticRenderFns } from "./ReferenceIndex.vue?vue&type=template&id=ce556420&"
import script from "./ReferenceIndex.vue?vue&type=script&lang=js&"
export * from "./ReferenceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports